<section class="settings-card">
  <header class="card-header">
    <div class="header-icon"><i [class]="icon"></i></div>
    <div class="header-copy">
      <h2>{{ title }}</h2>
      <p>{{ description }}</p>
    </div>
    @if (badge !== null) {
      <span class="card-badge">{{ badge }}</span>
    }
  </header>

  <ng-content />
</section>
